export const getTimezoneAbbreviation = (date: string): string => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timeZoneName =
    new Intl.DateTimeFormat('en-US', {
      timeZone: userTimezone,
      timeZoneName: 'short',
    })
      .formatToParts(new Date(date))
      .find(part => part.type === 'timeZoneName')?.value ?? '';
  return timeZoneName;
};
